import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import FireBase from '../firebase/firebase';

export default function UpdatedBook() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [updateData, setUpdateData] = useState({ book: '', author: '', status: '' });

  const _onChange = (e) => {
    setUpdateData((prevaData) => ({ ...prevaData, [e.target.name]: e.target.value }));
  };

  /**
   ** get Book by id
   */
  useEffect(() => {
    (async function () {
      const fetchData = await FireBase.getBook(id);
      const Data = fetchData.data();

      //! setUpdateData
      setUpdateData(Data);
    })();
  }, [id]);

  //! edit
  const handleSubmit = (e) => {
    e.preventDefault();

    const UpdatedData = { book: updateData.book, author: updateData.author, status: updateData.status };
    //! updating book
    FireBase.updateBook(id, UpdatedData);

    //! navigate to home page
    navigate('/');
  };

  return (
    <div className='updated'>
      <div className='container mt-5'>
        <form>
          <div className='mb-3'>
            <input
              type='text'
              className='form-control'
              id='book'
              aria-describedby='emailHelp'
              placeholder='Book Name'
              required
              onChange={_onChange}
              name='book'
              value={updateData.book}
            />
          </div>
          <div className='mb-3'>
            <input
              type='text'
              className='form-control'
              id='author'
              placeholder='Author Name'
              required
              onChange={_onChange}
              name='author'
              value={updateData.author}
            />
          </div>
          <div className='mb-3'>
            <select
              id='disabledSelect'
              className='form-select'
              onChange={_onChange}
              name='status'
              value={updateData.status}
              required
            >
              <option>select status</option>
              <option value='Available'>Available</option>
              <option value='UnAvailable'>UnAvailable</option>
            </select>
          </div>
          <hr />
          <button type='submit' className='btn btn-primary' onClick={handleSubmit}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
